import { ModalProps } from 'UIKit/ModalV2'
import { RouteConfig } from 'config/constants/route'
import { Token } from 'config/types'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import DesktopPaymentModal from './DesktopPayment'
import { DepositOptionEnums, PaymentPageEnums } from './Menu'
import MobilePayment from './MobilePayment'

export const TransactionUrls = {
  [PaymentPageEnums.Deposit]: RouteConfig.DepositTransactionHistory,
  [PaymentPageEnums.Withdraw]: RouteConfig.WithdrawTransactionHistory,
  [PaymentPageEnums.Swap]: RouteConfig.SwapTransactionHistory,
  [PaymentPageEnums.Tip]: RouteConfig.TipTransactionHistory,
}

export interface PaymentProps {
  defaultPage?: PaymentPageEnums
  initialToken?: Token
  pageData?: { tipUserName?: string; depositSubTag?: DepositOptionEnums }
}

const Payment: React.FC<ModalProps<PaymentProps>> = ({
  data: { defaultPage = PaymentPageEnums.Deposit, initialToken, pageData },
  onDismiss,
}) => {
  const { isMobile } = useMatchBreakpoints()

  return isMobile ? (
    <MobilePayment onDismiss={onDismiss} data={{ defaultPage, initialToken, pageData }} />
  ) : (
    <DesktopPaymentModal onDismiss={onDismiss} data={{ defaultPage, initialToken, pageData }} />
  )
}

export default Payment
